import React from 'react'
import Navbar from './Navbar'
import Footer from './Footer'

const Privacypolicy = () => {
    return (
        <>
            <Navbar />

            <main className="site-content">
                {/* <!-- start: Breadcrumb Area --> */}
                <section className="breadcrumb-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="breadcrumb-content-area">
                                    <div className="breadcrumb-heading">
                                        <h1 className="breadcrumb-title">Privacy Policy</h1>
                                    </div>
                                    <div className="breadcrumb-link">
                                        <span>
                                            <a href="/">
                                                <span>Home</span>
                                            </a>
                                        </span>
                                        <i className="fa-light fa-angle-right"></i>
                                        <span>
                                            <span>Privacy Policy</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tj-breadcrumb-shape">
                        <div className="breadcrumb-shape-one">
                            <img src="assets/images/shape/shape-55.svg" alt="Shape" />
                        </div>
                        <div className="breadcrumb-shape-two">
                            <img src="assets/images/shape/breadcrumb-2.svg" alt="Shape" />
                        </div>
                        <div className="breadcrumb-shape-1 pulse">
                            <img src="assets/images/shape/shape-55.svg" alt="Icon" />
                        </div>
                        <div className="breadcrumb-shape-2 shake-y">
                            <img src="assets/images/shape/shape-4.svg" alt="Icon" />
                        </div>
                        <div className="breadcrumb-shape-3 pulse">
                            <img src="assets/images/shape/shape-6.svg" alt="Icon" />
                        </div>
                        <div className="breadcrumb-shape-4 shake-y">
                            <img src="assets/images/shape/shape-4.svg" alt="Icon" />
                        </div>
                        <div className="breadcrumb-shape-5 pulse">
                            <img src="assets/images/shape/shape-6.svg" alt="Icon" />
                        </div>
                        <div className="breadcrumb-shape-6 pulse">
                            <img src="assets/images/shape/shape-51.svg" alt="Icon" />
                        </div>
                        <div className="breadcrumb-shape-7 shake-y">
                            <img src="assets/images/shape/shape-5.svg" alt="Icon" />
                        </div>
                        <div className="breadcrumb-shape-8 pulse">
                            <img src="assets/images/shape/shape-6.svg" alt="Icon" />
                        </div>
                    </div>
                </section>
                {/* <!-- end: Breadcrumb Area --> */}

<div className='tj-portfolio-section-three tj-sec-heading'>
             <div>
                <div className="container">
                    <h2 className='sec-title'  style={{marginBottom:'30px'}}>Privacy Policy – Jaipur Solitare  Lab</h2>
                    <p>Your privacy is our priority.</p>
                    <p  style={{marginBottom:'30px'}}>At Jaipur Solitare  Lab, we are committed to safeguarding your personal information and ensuring a safe online experience. We use advanced security technologies and protocols in collaboration with trusted partners like SSL Secure, Anti-Virus Secure, and GEO-TRUST to ensure your data remains protected at all times. We collect minimal data and do not require any personal information to make a payment.</p>

                    <div  style={{marginBottom:'30px'}}>
                        <h4>1. Information We Collect</h4>
                        <p>We may collect and store the following types of information:</p>
                        <ul className='mb-2' style={{listStyle:'none'}}>
                            <li className='mb-1'><b>Personal Details:</b> When you subscribe, register, or contact us through our website, we may collect basic personal information such as your name, email address, or contact number.</li> 
                            <li><b>Automatic Data:  </b> When you browse our website, certain technical information may be automatically collected, including your IP address, browser type, device type, and pages visited. Please note that your IP address does not personally identify you.</li>
                        </ul>
                    </div>

                    <div  style={{marginBottom:'30px'}}>
                        <h4>2. How We Use Your Information</h4>
                        <p>The information collected may be used to:</p>
                        <p>Improve our services and website functionality</p>
                        <p>Respond to inquiries or customer service requests</p>
                        <p>Send updates related to our lab reports, services, or policies (only if you've subscribed)</p>
                    </div>

                    <div style={{marginBottom:'30px'}}>
                        <h4>3. Data Security</h4>
                        <p>We employ robust monitoring and antifraud systems to prevent unauthorized access and data misuse. Your personal data is handled with strict confidentiality and is never sold or shared with third-party marketers without your consent.</p>
                    </div>

                    <div  style={{marginBottom:'30px'}}>
                        <h4>4. India Privacy Rights</h4>
                        <p>If you are a resident of India and a customer of Jaipur Solitare  Lab, you have the right to request details of how we share your personal information with third parties for direct marketing. To request this information, please contact us at:</p>
                        <p>📧 Email: <a href="">info@jaipursolitare lab.in</a></p>
                        <p>📞 Phone: +91-XXXXXXXXXX </p>
                    </div>

                    <div  style={{marginBottom:'30px'}}>
                        <h4>5. Contact Us</h4>
                        <p>If you have any questions or concerns regarding this Privacy Policy or our data practices, please contact us through our website or reach out to us directly:</p>
                        <p>📧 Email: <a href="">info@jaipursolitare lab.in</a></p>
                        <p>📞 Phone: +91-XXXXXXXXXX</p>
                        <p>🌐 Website: www.jaipurSolitare lab.in</p>
                    </div>
                </div>
            </div>
            <div className="portfolio-bg-shape">
                        <div className="portfolio-shape shake-y">
                            <img src="assets/images/shape/portfolio-shape2.svg" alt="Shape" />
                        </div>
                        <div className="portfolio-shape1 shake-y">
                            <img src="assets/images/shape/portfolio-shape2.svg" alt="Shape" />
                        </div>
                    </div>
           </div>

            </main>

           
            <Footer />
        </>
    )
}

export default Privacypolicy
